import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";
import local from "@/utils/local";

Vue.use(Vuex);

const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default new Vuex.Store({
  state: {
    line:'',
    new_customer:'',
    isLoading: false, // 是否展示loading动画
    orderBy: "sale", // 根据什么字段排序
    goodsInfo: {
      // 商品详情
      goodsImg: [],
      title: "",
      tags: [],
      discount: [],
      promotion: [],
      remarksNum: 0,
      setMeal: [],
      hot: [],
      goodsDetail: [],
      param: [],
      remarks: []
    },
    token: {}, //储存token
    potToken: {}, //储存token
    requireAuth: {}, //验证token
    userInfo: {
      // 用户信息
      username: ""
    },
    signUpStep: 0, // 登录步骤
    PayStep: 0, // 结算步骤
    marketing: {
      // 营销
      CarouselItems: [], // 轮播图
      activity: [] // 活动
    },
    seckills: {
      // 秒杀
      deadline: {
        hours: 0,
        minute: 0,
        seconds: 0
      },
      goodsList: []
    },
    weekSpecial: {
      // 每周特价
      weeklyDeadline: {
        hours: 0,
        minute: 0,
        seconds: 0
      },
      specialList: []
    },
    computer: {}, // 电脑专栏
    eat: {}, // 爱吃专栏
    asItems: [], // 广告
    goodsList: [], // 商品列表
    shoppingCart: [], // 购物车
    newShoppingCart: [], // 刚加入的购物车，作为展示
    recommend: [], // 推荐购买
    navData: local.get("nav") ? JSON.parse(local.get("nav")) : [], // 顶部navvar 数据
    curNav: local.get("curNav") ? parseInt(local.get("curNav")) + "" : "" ,// 当前激活状态的导航栏

    //积分列表数组
    indexList:[],

    //游乐豆列表数组
    indexyldList:[],

    //积分详情
    integral:{},
    //游乐豆详情
    integralyld:{},
  },
  modules,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js